/**
 * Created by Ivan on 07.08.2026
 */

class MaxScaleComponent extends BaseComponent {
    onCreate() {
        this.maxScale = PrefabBuilder.resolveProperty(this.options.maxScale, this.context) || 1;
        this.padX = this.options.padX || 0;
        this.padY = this.options.padY || 0;
    }

    getMaxScale() {
        return Array.isArray(this.maxScale) ? this.maxScale[cleverapps.resolution.mode] : this.maxScale;
    }

    onResize() {
        if (!this.node.width || !this.node.height) {
            return;
        }

        const sceneSize = cleverapps.resolution.getSceneSize();
        const scale = Math.min(this.getMaxScale(), (sceneSize.width - this.padX) / this.node.width, (sceneSize.height - this.padY) / this.node.height);
        this.node.setScale(scale);
    }
}

MaxScaleComponent.getMaxScale = function (node) {
    const component = ComponentUtils.findComponent(node, MaxScaleComponent);
    return component ? component.getMaxScale() : 1;
};

Prefab.registerComponent("MaxScaleComponent", MaxScaleComponent);
